class scrollDown {
    constructor(triggerBtn, element) {
        this.btn = document.querySelector(triggerBtn);
        this.element = document.querySelector(element);

        if (_.isNull(this.btn) === false && _.isNull(this.element) === false) {
            this.init();
        }
    }

    init() {
        this.btn.addEventListener('click', (el, i) => {
            const elementHeight = this.element.scrollHeight;
            animateScroll(this.element, 1000, 'easeInOutCubic', elementHeight, 'bottom');
        });
    }
}

module.exports = scrollDown;